var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.2525 11H69.4525L49.3525 36.8643L73 72.0526H54.485L39.985 50.7083L23.39 72.0526H14.185L35.685 44.3871L13 11.0028H31.985L45.0925 30.5122L60.2525 11ZM57.025 65.8553H62.1225L29.215 16.8736H23.745L57.025 65.8553Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXDefault);
export default __webpack_public_path__ + "static/media/X_Default.84f6459e965c4868687b8381258f6783.svg";
export { ForwardRef as ReactComponent };